import React from "react"
import PropTypes from "prop-types"

class NumberForm extends React.Component {
  submit = e => {
    e.preventDefault()
    this.props.onConfirm()
  }

  componentDidMount() {
    this.textInput.focus()
  }

  render() {
    const {onConfirm, onChange, onCancel} = this.props
    return (
      <form className="shop-reservation__price-form" onSubmit={this.submit}>
        <input type="number" step="0.01" min="0" max="10000"
          ref={input => {this.textInput = input}} onChange={onChange} />
        <button type="button" className="btn btn-success" onClick={onConfirm}>Ok</button>&nbsp;
        <button type="button" className="btn btn-danger" onClick={onCancel}>X</button>
      </form>
    )
  }
}

NumberForm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default NumberForm
